const mobileGallery = window.matchMedia('(max-width: 999px)');
const fallbackTimers = new WeakMap();
let pending = false;

function showFallbackIfMockupFails(gallery) {
  if (!gallery?.classList.contains('teeinblue-gallery-awaiting') || fallbackTimers.has(gallery)) return;

  const timer = window.setTimeout(() => {
    fallbackTimers.delete(gallery);
    if (gallery.isConnected && !gallery.classList.contains('teeinblue-mixed-gallery')) {
      gallery.classList.add('teeinblue-gallery-failed');
    }
  }, 10000);

  fallbackTimers.set(gallery, timer);
}

function cancelFallback(gallery) {
  const timer = fallbackTimers.get(gallery);
  if (timer === undefined) return;
  window.clearTimeout(timer);
  fallbackTimers.delete(gallery);
}

function syncTeeinblueGallery() {
  pending = false;

  const teeGallery = document.getElementById('tee-gallery');
  const gallery = teeGallery?.closest('media-gallery')
    || document.querySelector('main media-gallery.product-media-gallery--locked-pdp.teeinblue-mixed-gallery')
    || document.querySelector('main media-gallery.teeinblue-gallery-awaiting');

  if (!teeGallery || !gallery) {
    gallery?.classList.remove('teeinblue-mixed-gallery');
    gallery?.querySelectorAll('.tee-gallery-slot--mounted').forEach((slot) => slot.classList.remove('tee-gallery-slot--mounted'));
    showFallbackIfMockupFails(gallery);
    return;
  }

  const slotSelector = mobileGallery.matches
    ? '.product-media-gallery__mobile-slideshow [data-tee-gallery-slot]'
    : '.product-media-gallery__desktop-stack [data-tee-gallery-slot]';
  const slot = gallery.querySelector(slotSelector);

  if (!slot) return;

  const moved = teeGallery.parentElement !== slot;
  if (moved) {
    slot.append(teeGallery);
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }

  const mockupReady = teeGallery.querySelector('.tee-mockup-item--loaded')
    && teeGallery.querySelector('.tee-slider')?.getBoundingClientRect().width > 0;

  if (!mockupReady) {
    gallery.classList.remove('teeinblue-mixed-gallery');
    gallery.querySelectorAll('.tee-gallery-slot--mounted').forEach((item) => item.classList.remove('tee-gallery-slot--mounted'));
    showFallbackIfMockupFails(gallery);
    return;
  }

  cancelFallback(gallery);
  gallery.classList.remove('teeinblue-gallery-failed');
  const wasMounted = gallery.classList.contains('teeinblue-mixed-gallery');

  gallery.querySelectorAll('[data-tee-gallery-slot]').forEach((item) => {
    item.classList.toggle('tee-gallery-slot--mounted', item === slot);
  });
  gallery.classList.add('teeinblue-mixed-gallery');
  if (!wasMounted && !moved) {
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }
}

function scheduleSync() {
  if (pending) return;
  pending = true;
  requestAnimationFrame(syncTeeinblueGallery);
}

function startBridge() {
  if (window.teeinblueGalleryBridgeStarted) return;
  window.teeinblueGalleryBridgeStarted = true;

  new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
  mobileGallery.addEventListener('change', scheduleSync);
  scheduleSync();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startBridge, { once: true });
} else {
  startBridge();
}
